export class CalendarRange {
    startDate: Date;
    endDate: Date;
}